import { environment } from "../../../../environments/environment";
import { AppConfig } from "../../../../libs/config/app.lib.config";

const host = environment.withProxy
	? "local.ca-digit.com:4200"
	: window.location.host;

export const TM_APP_CONFIG: AppConfig = {
	app: "tm2",
	version: environment.version,
	versionLabel: environment.buildInfo.label,
	apiUrl: "https://" + host + "/api/v1",
	sapApiUrl: "https://" + window.location.host + "/api/v1/b1sl",
	locale: "de",
	production: environment.production,
	sentryDSN: environment.sentryDSN,
};
